import React from 'react';
import { SectionHeader } from '../components/SectionHeader';
import { DetailReadOnlyField } from '../components/DetailFields';
import { detailGrid2 } from '../storeDetailsConstants';
import {
  formatBoolFromNumber,
  formatCoordinates,
  formatDateTime,
  formatDetailValue,
  titleCase,
} from '../storeDetailsUtils';

export function AddressSection({ meta, store }) {
  const addr = store?.address ?? {};
  const geo = addr.Geolocation ?? {};

  return (
    <>
      <SectionHeader Icon={meta.Icon} title={meta.title} subtitle={meta.subtitle} />

      <div style={detailGrid2}>
        <div style={{ gridColumn: '1 / -1' }}>
          <DetailReadOnlyField label="Address line" value={addr.address} />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <DetailReadOnlyField label="Formatted address" value={geo.formattedAddress} />
        </div>
        <DetailReadOnlyField label="Street" value={geo.street} />
        <DetailReadOnlyField label="City" value={titleCase(geo.city)} />
        <DetailReadOnlyField label="State" value={titleCase(geo.state)} />
        <DetailReadOnlyField label="Zipcode" value={geo.zipcode} />
        <DetailReadOnlyField label="County" value={titleCase(geo.county)} />
        <DetailReadOnlyField label="Country" value={titleCase(geo.country)} />
        <DetailReadOnlyField label="Coordinates" value={formatCoordinates(geo.coordinates)} />
        <DetailReadOnlyField label="Google place ID" value={geo.googlePlaceId} />
        <DetailReadOnlyField label="Delivery radius (mi)" value={formatDetailValue(addr.radius)} />
        <DetailReadOnlyField label="Address status" value={formatBoolFromNumber(addr.status)} />
        <DetailReadOnlyField label="Address created" value={formatDateTime(addr.create_at)} />
      </div>
    </>
  );
}
